import { MentorshipRequest, Mentorship, Program, Cohort } from '../types';

export const mockMentorshipRequests: MentorshipRequest[] = [
  {
    id: 'req_1',
    entrepreneurId: 'user_emprendedor_1',
    mentorId: 'user_mentor_1',
    projectId: 'p1',
    message: 'Necesito ayuda con la estrategia financiera para mi próxima ronda de inversión',
    status: 'accepted',
    createdAt: '2024-02-01T10:00:00Z',
    respondedAt: '2024-02-02T14:00:00Z'
  },
  {
    id: 'req_2',
    entrepreneurId: 'user_emprendedor_2',
    mentorId: 'user_mentor_2',
    projectId: 'p2',
    message: 'Me gustaría recibir mentoría en marketing digital para escalar mi startup',
    status: 'accepted',
    createdAt: '2024-02-15T10:00:00Z',
    respondedAt: '2024-02-16T09:00:00Z'
  },
  {
    id: 'req_3',
    entrepreneurId: 'user_emprendedor_3',
    mentorId: 'user_mentor_3',
    projectId: 'p3',
    message: 'Necesito orientación técnica para desarrollar el MVP de mi plataforma',
    status: 'pending',
    createdAt: '2024-04-10T10:00:00Z'
  },
  {
    id: 'req_4',
    entrepreneurId: 'user_emprendedor_4',
    mentorId: 'user_mentor_1',
    projectId: 'p4',
    message: 'Busco asesoría para estructurar mi modelo financiero',
    status: 'accepted',
    createdAt: '2024-02-20T10:00:00Z',
    respondedAt: '2024-02-21T11:00:00Z'
  },
  {
    id: 'req_5',
    entrepreneurId: 'user_emprendedor_1',
    mentorId: 'user_mentor_4',
    projectId: 'p1',
    message: 'Necesito ayuda para estructurar mi equipo y cultura organizacional',
    status: 'rejected',
    createdAt: '2024-03-01T10:00:00Z',
    respondedAt: '2024-03-02T10:00:00Z'
  }
];

export const mockMentorships: Mentorship[] = [
  {
    id: 'mentorship_1',
    entrepreneurId: 'user_emprendedor_1',
    mentorId: 'user_mentor_1',
    projectId: 'p1',
    startDate: '2024-02-05T00:00:00Z',
    status: 'active',
    sessionsCount: 5,
    notes: 'Progreso excelente en la estructuración financiera'
  },
  {
    id: 'mentorship_2',
    entrepreneurId: 'user_emprendedor_2',
    mentorId: 'user_mentor_2',
    projectId: 'p2',
    startDate: '2024-02-20T00:00:00Z',
    status: 'active',
    sessionsCount: 3,
    notes: 'Trabajando en estrategia de adquisición de usuarios'
  },
  {
    id: 'mentorship_3',
    entrepreneurId: 'user_emprendedor_4',
    mentorId: 'user_mentor_1',
    projectId: 'p4',
    startDate: '2024-02-25T00:00:00Z',
    endDate: '2024-04-15T00:00:00Z',
    status: 'completed',
    sessionsCount: 6,
    notes: 'Mentoría completada exitosamente. Modelo financiero validado.'
  }
];

export const mockPrograms: Program[] = [
  {
    id: 'program_1',
    name: 'Programa de Aceleración Fintech 2024',
    description: 'Programa intensivo de 6 meses para startups fintech',
    type: 'Aceleración',
    startDate: '2024-01-15T00:00:00Z',
    endDate: '2024-07-15T00:00:00Z',
    status: 'active',
    cohortIds: ['cohort_1'],
    adminId: 'user_admin_1'
  },
  {
    id: 'program_2',
    name: 'Incubadora HealthTech 2024',
    description: 'Incubadora para proyectos de salud digital',
    type: 'Incubación',
    startDate: '2024-02-01T00:00:00Z',
    endDate: '2024-08-01T00:00:00Z',
    status: 'active',
    cohortIds: ['cohort_2'],
    adminId: 'user_admin_2'
  },
  {
    id: 'program_3',
    name: 'Bootcamp EdTech 2024',
    description: 'Programa de capacitación intensiva para emprendedores EdTech',
    type: 'Capacitación',
    startDate: '2024-05-01T00:00:00Z',
    endDate: '2024-06-30T00:00:00Z',
    status: 'upcoming',
    cohortIds: [],
    adminId: 'user_admin_1'
  }
];

export const mockCohorts: Cohort[] = [
  {
    id: 'cohort_1',
    programId: 'program_1',
    name: 'Cohorte Fintech Q1 2024',
    projectIds: ['p1', 'p4'],
    startDate: '2024-01-15T00:00:00Z',
    endDate: '2024-07-15T00:00:00Z'
  },
  {
    id: 'cohort_2',
    programId: 'program_2',
    name: 'Cohorte HealthTech 2024',
    projectIds: ['p2'],
    startDate: '2024-02-01T00:00:00Z',
    endDate: '2024-08-01T00:00:00Z'
  }
];
